/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class EsriQueryConfigurationModel {
        public currentQuery:Wars.Domain.Model.Gis.EsriQueryConfiguration;
        public mapConfiguration:Wars.Domain.Model.Gis.MapConfiguration;
        public selectedLayer:Wars.Domain.Model.Gis.Layer;
        public selectedMapServiceLayer:Wars.Domain.Model.Gis.EsriMapServiceLayerMetadata;

        constructor(private mapConfigurationService: services.MapConfigurationService,
            private deleteService: services.DeleteService,
            private $q: angular.IQService,
            private esriMapService:services.EsriMapService,
            private mapConfigurationId:string) {

            mapConfigurationService.getMapConfiguration(mapConfigurationId).then(m => {
                this.mapConfiguration = m;
            });

        }

        public addQuery() {
            this.currentQuery = this.mapConfigurationService.createEsriQueryConfiguration();
            this.currentQuery.name = "New Query";

            this.currentQuery.returnGeometry = false;
            this.currentQuery.useOrForWheres = false;
            this.currentQuery.hasLayerInfoBeenRetrieved = false;
            this.currentQuery.includeGeometryFilter= false;
            this.currentQuery.layer = this.selectedLayer;

            this.mapConfiguration.esriQueryConfigurations.push(this.currentQuery);

            this.save();
        }

        public getLayerInfo() {
            this.esriMapService.loadLayerMetadata(this.currentQuery.layer,this.selectedMapServiceLayer);
        }

        public mapServiceLayerChanged() {
            var d = this.$q.defer();

            var promise = d.promise;

            if (!this.currentQuery.esriMapServiceLayerMetadata.fields || this.currentQuery.esriMapServiceLayerMetadata.fields.length == 0) {
                this.esriMapService.loadLayerMetadata(this.currentQuery.layer, this.currentQuery.esriMapServiceLayerMetadata).then(r => {
                    d.resolve();
                })
            } else {
                d.resolve();
            }

            promise.then(r => {
                this.currentQuery.wherePredicates.forEach(f=>f.entityAspect.setDeleted());
                this.save();
            });
        }


        public save() {
            this.mapConfigurationService.saveAllChanges();
        }

        public geometryFilterChanged() {
            if (this.currentQuery.includeGeometryFilter && !this.currentQuery.geometryFilter) {
                this.currentQuery.geometryFilter = this.mapConfigurationService.createGeometryFilter();
                this.currentQuery.geometryFilter.geometryComparisionType = Wars.Domain.Model.Codes.Enums
                    .GeometryComparisionType.EnvelopeIntersects;
                this.currentQuery.geometryFilter.useMapGeometry = false;
                this.currentQuery.geometryFilter.bufferFactor=0;
            }

            this.save();
        }


    }

}